import { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import { ImDownload3, ImUpload } from 'react-icons/im';

const FileUploadClient = ({ brandingColours, eventId, user, clientId }) => {

  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [isDragging, setIsDragging] = useState(false);
  const fileInputRef = useRef(null);

  const downloadButtonStyle = {
    cursor: 'pointer',
    backgroundColor: brandingColours?.primaryColor || '#FFFFFF',
    color: brandingColours?.secondaryColor || '#080700',
    border: '1px solid #D9D9D9',
    borderRadius: '3px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: '500',
    fontSize: '12px',         
    // --- CHANGED SHOWN BELOW ---
    width: 'fit-content',      // Button shrinks/grows with text
    minWidth: '100px',         // Ensures it doesn't get too tiny
    padding: '0 15px',         // Adds space on left/right so text doesn't hit borders
    height: '30px',
    textDecoration: 'none',    
    whiteSpace: 'nowrap',      // Keeps "Download" on one line
  };

  const uploadContainerStyle = {
    border: '1px solid #D9D9D9',
    padding: '20px',
    textAlign: 'center',
    borderRadius: '5px',
    cursor: 'pointer',
    marginBottom: '20px',
    backgroundColor: '#e0e0e0'  
  };

  const uploadTextStyle = {
    margin: 0,
    fontSize: '14px',
    color: '#888'
  };

  const uploadIconStyle = {
    fontSize: '30px',
    marginBottom: '10px'
  };

  const fileItemStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: '1px solid #eee',
    padding: '10px 0'
  };

  const fileInfoStyle = {
    display: 'flex',
    flexDirection: 'column'
  };

  const formatDate = (isoDate) => {
    const date = new Date(isoDate);
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    const [month, day, year] = date.toLocaleDateString('en-US', options).split(' ');
    return `Uploaded: ${month}-${day.replace(',', '')}-${year}`;
  };

  const fetchFiles = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/getClientFiles/${clientId}`, {withCredentials:true},
      );
      setUploadedFiles(response.data.files);
    } catch (error) {
      console.error('Failed to fetch files', error);
    }
  };

  useEffect(() => {
    fetchFiles();
  }, []);

  const handleDragEnter = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const files = e.dataTransfer.files;
    handleFiles(files);
  };

  const handleFileChange = (e) => {
    const files = e.target.files;
    handleFiles(files);
  };

  const handleFiles = async (files) => {
    const file = files[0];
    const formData = new FormData();
    formData.append('file', file);

    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/uploadFile/${clientId}}`,
        formData,
        { withCredentials: true }
      );
      fetchFiles(); 
    } catch (err) {
      console.error('Upload failed', err);
    }
  };

  return (
    <div style={{ marginTop: '15px', width: '100%'}}>
      <div
        style={uploadContainerStyle}
        onDragEnter={handleDragEnter}
        onDragOver={(e) => e.preventDefault()}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
        onClick={() => fileInputRef.current.click()}
      >
        <input
          type="file"
          onChange={handleFileChange}
          multiple
          style={{ display: 'none' }}
          ref={fileInputRef}
        />
        <div style={uploadIconStyle}><ImUpload /></div>
        <p style={uploadTextStyle}>Drag and drop files or click to upload</p>
      </div>

      <div>
        {uploadedFiles.map((file, index) => (
          <div key={index} style={fileItemStyle}>
            <div style={fileInfoStyle}>
              <p style={{ margin: '0', fontWeight: 'bold' }}>{file.name}</p>
              <p style={{ margin: '0', fontSize: '12px', color: '#666' }}>
                {formatDate(file.uploadedAt)}
              </p>
            </div>
            <a
  href={file.url}
  download={file.name}
  style={downloadButtonStyle}
>
  <span style={{ 
    display: 'flex', 
    marginRight: '7px', 
    color: brandingColours?.secondaryColor || '#080700' 
  }}>
    <ImDownload3 />
  </span>
  Download
</a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FileUploadClient;
